import React from 'react';

const LayoutEmpty = ({children}) => 
(
    <div>
        {children}
    </div>
);

export default LayoutEmpty;